import * as angular from "angular";

export class IntegrationService {
    private v2ApiRoot: string;
    private $http: any;

    constructor($http: any) {
        this.$http = $http;
        this.v2ApiRoot = "/v2/integration";
    }

    all(): Promise<object> {
        return this.$http.get(this.v2ApiRoot);
    }

    install(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/install`);
    }

    uninstall(data: any): Promise<object> {
        return this.$http.post(this.v2ApiRoot + `/${data.id}/uninstall`, data);
    }
    audience(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/audience`);
    }

    audienceSet(data: any): Promise<object> {
        return this.$http.get(
            this.v2ApiRoot + `/${data.id}/audience/${data.audience}`
        );
    }

    fields(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/fields`);
    }

    statuses(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/statuses`);
    }

    getMapping(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/mapping`);
    }

    loginFields(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/auth/fields`);
    }

    login(data: any): Promise<object> {
        return this.$http.post(this.v2ApiRoot + `/${data.id}/auth/login`, data);
    }

    pull(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/pull`);
    }

    updateSettings(data: any): Promise<object> {
        return this.$http.post(this.v2ApiRoot + `/${data.id}/settings`, data);
    }

    listViews(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/listviews`);
    }

    sync(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/sync`);
    }

    stop(data: any): Promise<object> {
        return this.$http.get(this.v2ApiRoot + `/${data.id}/stop`);
    }

    saveMapping(data: any): Promise<object> {
        return this.$http.post(this.v2ApiRoot + `/${data.id}/statuses`, data);
    }
}

angular.module("vcServices").service("IntegrationService", IntegrationService);
